<template>
  <div>
    <v-card class="rounded-lg shadow mt-3">
      <v-card-title>
        Tableau récapitulatif des gagnants
      </v-card-title>
      <v-divider/>
      <v-overlay :value="overlay"
                 absolute
                 color="white"
                 opacity="0.5">
        <v-progress-circular
            color="primary"
            indeterminate
            size="50"
        ></v-progress-circular>
      </v-overlay>

      <v-card-title>
        <div>
          <v-text-field
              v-model="keyword"
              @click:clear="[keyword = null,getUsages()]"
              @keydown.enter="getUsages"
              append-icon="mdi-magnify"
              clearable
              dense
              filled
              hide-details
              placeholder="Recherche..."
              rounded
              single-line
          ></v-text-field>
        </div>

        <v-spacer/>

        <v-btn color="grey"
               text
               @click="$refs.filterDialog.open()">
          <v-icon left>mdi-filter-outline</v-icon>
          Filtre
        </v-btn>

        <v-btn color="grey"
               @click="exportExcel"
               text>
          <v-icon left>mdi-export</v-icon>
          Exporter
        </v-btn>

        <v-btn color="grey"
               text
               @click="handleFilter">
          <v-icon left>mdi-refresh</v-icon>
          Mettre à jour
        </v-btn>

      </v-card-title>

      <v-divider/>

      <v-card-text v-if="isLoading" class="pa-0">
        <v-skeleton-loader type="table"/>
      </v-card-text>

      <div v-else>

        <v-card-text>

          <v-simple-table class="rounded-lg table-border" v-if=" usages.length">
            <template v-slot:default>
              <thead>
              <tr>
                <th>Code</th>
                <th>Utilisateur</th>
                <th>Téléphone</th>
                <th>Wilaya</th>
                <th>Commune</th>
                <th>Cadeau</th>
                <th v-if="can('admin')">Tracer <br> dans l’historique</th>
                <th v-if="can('admin')">POS</th>
                <th v-if="can('admin')">Platform</th>
                <th>Date</th>
                <th v-if="can('admin')">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,i) in  usages" :key="i">

                <td class="text-no-wrap gifty--text font-weight-medium">
                  #{{ item.boosting_code?.code }}
                </td>

                <td>
                  <Avatar v-if="item.account && item.account"
                          :user="item.account"
                          :byAccount="true"/>
                  <span v-else>-</span>
                </td>

                <td class="text-no-wrap">
                  {{ item.account?.user.phone }}
                </td>


                <td class="text-no-wrap">
                  {{ item.account?.user.wilaya?.name }}
                </td>

                <td class="text-no-wrap">
                  {{ item.account?.user.commune?.name }}
                </td>

                <td>
                  <v-chip color="success" small>
                    <v-icon left small>
                      mdi-gift-outline
                    </v-icon>
                    {{ item.boosting_physical_gift?.name ?? CurrencyFormatting(item.user_winning_amount) + " DZD" }}
                  </v-chip>
                </td>

                <td v-if="can('admin')">
                  <v-switch v-model="item.track_in_history"
                            v-if="item.boosting_physical_gift_id"
                            class="pa-0 ma-0"
                            color="success"
                            hide-details
                            readonly
                            @click="changeStatus(item.id)"></v-switch>

                </td>

                <td class="text-no-wrap" v-if="can('admin')">
                  <Avatar v-if="item.salepoint_account && item.salepoint_account"
                          :user="item.salepoint_account"
                          :byAccount="true"/>
                  <span v-else>-</span>
                </td>

                <td v-if="can('admin')">
                  <v-chip color="info" small>
                    <v-icon left small> {{
                        item.platform_used === 'web' ? 'mdi-desktop-mac' : 'mdi-cellphone'
                      }}
                    </v-icon>
                    {{ item.platform_used }}
                  </v-chip>
                </td>

                <td class="text-no-wrap">
                  {{ dateFormat(item.used_at) }}
                </td>

                <td v-if="can('admin')">
                  <div class="d-flex">
                    <v-btn color="gifty" icon>
                      <v-icon>mdi-trash-can</v-icon>
                    </v-btn>
                  </div>
                </td>

              </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div v-else>
            <NoResults @reload="getUsages"/>
          </div>

        </v-card-text>

        <v-divider/>

        <v-card-actions>

          <div :style="{width : '120px'}">
            <v-select v-model="perPage"
                      :items="[10,20,30,50,100]"
                      dense
                      hide-details
                      label="Ligne par page"
                      outlined
            ></v-select>
          </div>

          <v-spacer/>


          <v-pagination v-model="pagination.current"
                        :length="pagination.total"
                        circle
                        total-visible="7"
                        @input="getUsages"></v-pagination>

        </v-card-actions>

      </div>

    </v-card>

    <FilterDialog ref="filterDialog" @filter="handleFilter"/>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import moment from "moment";
import Avatar from "@/components/Avatar";
import FilterDialog from "@/views/admin-boostings/dashboard/components/FilterDialog";
import NoResults from "@/components/NoResults";

export default {
  components: {
    Avatar,
    FilterDialog,
    NoResults,
  },
  props: ['boosting_method_id'],
  data() {
    return {
      id: null,
      isLoading: false,
      overlay: false,

      keyword: null,
      track_in_history: null,
      dates: [],

      usages: [],
      perPage: 10,
      pagination: {
        current: 1,
        total: 0
      },
    }
  },
  methods: {
    showAccount(account_id) {
      let route = this.$router.resolve({path: "/users/" + account_id})
      window.open(route.href, "_blank")
    },
    dateFormat(date) {
      return moment(date).format('DD/MM/YYYY, HH:mm')
    },
    getUsages() {
      this.isLoading = true
      if (!this.boosting_method_id) return;
      HTTP.get('/v1/boosting-methods/usages?page=' + this.pagination.current, {
        params: {
          perPage: this.perPage,
          keyword: this.keyword,
          dates: this.dates,
          track_in_history: this.track_in_history,
          boosting_method_id: this.boosting_method_id,
        }
      }).then(res => {
        this.isLoading = false
        this.pagination.current = res.data.data.data.current_page;
        this.pagination.total = res.data.data.data.last_page;
        this.usages = res.data.data.data.data

      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    handleFilter(e) {
      this.dates = e.dates
      this.track_in_history = e.track_in_history
      this.getUsages()
    },
    changeStatus(id) {
      this.overlay = true;
      HTTP.post("/v1/boosting-methods/usages/" + id + "/change-visibility").then(() => {
        this.overlay = false;
        let index = this.usages.findIndex(el => el.id === id)
        this.usages[index].track_in_history = !this.usages[index].track_in_history
        this.$successMessage = "Cet élément a été modifié avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
    exportExcel() {
      let user = this.$store.getters.getUser;
      let token = user.access_token;
      let DownloadURL =
          process.env.VUE_APP_FILE_URL +
          "/api/v1/boosting-methods/usages/export" +
          "?token=" +
          token +
          "&user_id=" +
          user.user.id +
          "&boosting_method_id=" +
          this.boosting_method_id;
      window.open(DownloadURL, "_blanc");
    },
  },
  created() {
    this.getUsages()
  },
  watch: {
    perPage() {
      this.pagination.current = 1
      this.getUsages()
    },
    boosting_method_id(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getUsages();
      }
    }
  },

}
</script>

<style scoped>

</style>